import config from '@/config';
import { Project, VersionList } from '@/types';

/**
 * This class it's temporary solution while "developers" project is in development. Should be replaced by sdk.
 */
export class DevelopersApi {
  private static readonly apiEndpoint = config.DEVELOPERS_API_URL;
  private static projectsRootPath = `${DevelopersApi.apiEndpoint}/projects`;

  static async getProjects(): Promise<Project[]> {
    return DevelopersApi.handleResponse(fetch(`${DevelopersApi.projectsRootPath}`), () => []);
  }

  static async getProjectVersions(projectName: string): Promise<Record<'dir', string[]>> {
    return DevelopersApi.handleResponse(fetch(`${DevelopersApi.projectsRootPath}/${projectName}?order=desc`));
  }

  static async getBatchProjectVersionsList(projectName: string, nextToken: string): Promise<VersionList> {
    if (nextToken) {
      return DevelopersApi.handleResponse(fetch(`${DevelopersApi.projectsRootPath}/scroll/${projectName}?nextToken=${encodeURIComponent(nextToken)}`));
    }
    return DevelopersApi.handleResponse(fetch(`${DevelopersApi.projectsRootPath}/scroll/${projectName}`));
  }

  static async deleteVersion(projectName: string, version: string):
  Promise<Partial<Record<'version' | 'project', string | null>>> {
    return DevelopersApi.handleResponse(
      fetch(`${DevelopersApi.projectsRootPath}/${projectName}/${version}`, { method: 'DELETE' })
    );
  }

  private static async handleResponse(req: Promise<Response>, onError?: () => any): Promise<any> {

    return req.then((response) => {
      if (response.ok) {
        return response.json();
      }

      if (onError) {
        return onError();
      } else {
        const error = new Error(response.statusText) as Error & {status: number;};
        error.status = response.status;
        throw error;
      }
    });
  }
}
